import React from "react";
import { styled } from "styled-components";
import { Info, Warning } from "../../assets/images";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";

const RideMap = ({ onClickInfo, onViewMap }) => {
  return (
    <RideMapContainer>
      <RideMapSubContainer>
        <WarningImage src={Warning} />
        <RideMapText>{Text.rideMap}</RideMapText>
        <RideInfoImage src={Info} onClick={() => onClickInfo()}/>
      </RideMapSubContainer>
      <ViewMapContainer onClick={() => onViewMap()}>
        <ViewMapText>{Text.viewMap}</ViewMapText>
      </ViewMapContainer>
    </RideMapContainer>
  );
};

const RideMapContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // border: 1px solid blue;
  @media only screen and (max-width: 1024px) {
    width: 100%;
  }
`;
const RideMapSubContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.3rem;
`;
const WarningImage = styled.img`
  width: 1.25rem;
  height: 1.125rem;
`;
const RideMapText = styled.span`
  color: ${Colors.black};
  font-size: 1.25rem;
  font-weight: 700;
`;
const RideInfoImage = styled.img`
  width: 0.87rem;
  height: 0.87rem;
  cursor: pointer;
`;
const ViewMapContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 0.3rem;
  cursor: pointer;
`;
const ViewMapText = styled.span`
  color: ${Colors.aqua};
  text-align: right;
  font-size: 1.25rem;
  font-weight: 600;
  text-decoration-line: underline;
`;

export default RideMap;
